import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import servicesData from '../Shared/servicesData';


function ServiceDetail() {
  const { id } = useParams();
  const service = servicesData.find(service => service.id === parseInt(id));
  const navigate = useNavigate();

  if (!service) {
    return (
      <div className="pt-20 font-tt-lakes text-center min-h-screen bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
          <h1 className="text-4xl font-bold text-marine-black mb-4">Service not found</h1>
          <p className="text-gray-600">The service you are looking for does not exist.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="font-tt-lakes">
      
      <div className="bg-gradient-to-b from-marine-black to-black text-white py-32 relative">
        <div className="absolute top-0 left-0 right-0 h-1 bg-marine-red opacity-20"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">{service.title}</h1>
            <p className="text-lg text-gray-300 max-w-3xl mx-auto leading-relaxed">{service.shortDescription}</p>
          </div>
        </div>
      </div>

     
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="rounded-2xl overflow-hidden shadow-2xl transform hover:scale-[1.02] transition-all duration-500">
            <img
              src={service.image}
              alt={service.title}
              className="w-full h-[500px] object-cover"
            />
          </div>
          <div className="space-y-8">
            <div className="space-y-6">
              <h2 className="text-3xl font-bold text-marine-black">Service Overview</h2>
              <div className="w-20 h-1 bg-marine-red"></div>
              <p className="text-lg text-gray-600 leading-relaxed">{service.longDescription}</p>
            </div>
            
            
            <div className="bg-gray-50 rounded-xl p-8 shadow-inner">
              <h3 className="text-xl font-semibold text-marine-black mb-4">Key Features</h3>
              <ul className="space-y-3">
                {service.features?.map((feature, index) => (
                  <li key={index} className="flex items-center text-gray-600">
                    <span className="w-2 h-2 bg-marine-red rounded-full mr-3"></span>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

     
      <div className="bg-gradient-to-b from-gray-50 to-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto">
            <h2 className="text-3xl font-bold text-marine-black mb-6">
              Need Professional Support?
            </h2>
            <p className="text-gray-600 mb-8 text-lg">
              Our team of experts is ready to help you with any marine equipment needs.
            </p>
            <button className="bg-marine-red hover:bg-red-700 text-white px-10 py-4 rounded-lg transition-all duration-300 transform hover:scale-105 font-semibold" onClick={() => navigate('/contact')}>
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServiceDetail;